const urls = {
  // campaigns
  DASHBOARD: '/dashboard',
  CREATE_NEW_CAMPAIGN(workspaceId: number): string {
    return `/workspaces/${workspaceId}/campaign-templates`;
  },
  CAMPAIGN_BUILDER(workspaceId: number | string = ':workspaceId'): string {
    return `/workspaces/${workspaceId}/campaign-builder/:campaignId/:step`;
  },
  ALL_CAMPAIGNS(workspaceId: number | string = ':workspaceId'): string {
    return `/workspaces/${workspaceId}/campaigns`;
  },
  CAMPAIGN_ANALYTICS(workspaceId: number | string = ':workspaceId'): string {
    return `/workspaces/${workspaceId}/campaign-analytics/:campaignId`;
  },
  DELETED(workspaceId: number): string {
    return `/workspaces/${workspaceId}/campaigns/deleted`;
  },

  // ai-agents
  AI_AGENTS(workspaceId: number | string = ':workspaceId'): string {
    return `/workspaces/${workspaceId}/ai-agents`;
  },

  AI_AGENTS_CHAT(
    workspaceId: number | string = ':workspaceId',
    agentId: number | string = ':agentId'
  ): string {
    return `/workspaces/${workspaceId}/ai-agents/${agentId}/chat`;
  },

  AI_AGENTS_INSTRUCTIONS(
    workspaceId: number | string = ':workspaceId',
    agentId: number | string = ':agentId'
  ): string {
    return `/workspaces/${workspaceId}/ai-agents/${agentId}/instructions`;
  },

  // settings
  PROFILE: '/settings/profile',
  ALL_MEMBERS: '/settings/all-members',
  ALL_EMAILS: '/settings/all-emails',
  CHANGE_BILLING: '/settings/billing/change-billing',
  CHANGE_SUBSCRIPTION: '/settings/billing/change-subscription',
  API_KEYS: '/settings/api-keys',
  WEBHOOKS: '/settings/webhooks',
  EXCLUDED_DOMAINS: '/settings/excluded-domains',

  SETTINGS: '/settings',
  SETTINGS_BILLING: '/settings/billing',
  SETTINGS_BILLING_DETAILS: '/settings/billing/details',
  SETTINGS_BILLING_WITHDRAWAL_FEES: '/settings/billing/withdrawal-fees',
  SETTINGS_WORKSPACE: '/settings/workspaces',
  SETTINGS_CREATE_WORKSPACE: '/settings/workspace/create',
  INVOICE(id: number): string {
    return `/settings/billing/invoice/${id}`;
  },
  TEMPLATES: '/settings/templates',
  NEW_TEMPLATE: '/settings/new-template',

  INQUIRIES_FILTERS: '/inquiries/filter',
  INQUIRIES_FILTERS_CREATE: '/inquiries/filter/create',
  INQUIRIES_FILTERS_UPDATE: '/inquiries/filter/update',

  PERMISSION_DENIED: '/permission_denied',

  LOGIN: '/welcome',
  SIGNIN: '/login',
  REGISTER: '/register',
  SIGNUP: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESTORE_PASSWORD: '/restore',
  BD_LOGIN: '/bd/login',
  TRIAL: '/trial',
  AUTHORIZE_MICROSOFT_ERROR: '/authorize/microsoft/error',
  ONBOARDING_CALL: 'onboarding',
  ONBOARDING_ONBOARDING: '/onboarding/onboarding',
  ONBOARDING_MEMBERS: '/onboarding/members',
  ONBOARDING_TUTORIAL: '/onboarding/tutorial',

  ONBOARDING_FIRST_ORDER_TRANSITION: '/transition-first-order',
  ONBOARDING_SCHEDULE_CALL: '/schedule-call',
  CONCIERGE_FIRST_ORDER: '/first-order',

  MAINTENANCE: '/maintenance',
  UNSUBSCRIBE: '/unsubscribe',
  UNSUBSCRIBED: '/unsubscribed',

  // Concierge
  ORDERS(workspaceId: number | string = ':workspaceId'): string {
    return `/workspaces/${workspaceId}/orders`;
  },
  ORDER(
    workspaceId: number | string = ':workspaceId',
    orderId: number | string = ':orderId'
  ): string {
    return `/workspaces/${workspaceId}/orders/${orderId}`;
  },
  ORDER_INFO(
    workspaceId: number | string = ':workspaceId',
    orderId: number | string = ':orderId'
  ): string {
    return `/workspaces/${workspaceId}/orders/${orderId}/info`;
  },
  PLACEMENTS(workspaceId: number | string = ':workspaceId'): string {
    return `/workspaces/${workspaceId}/placements`;
  },
  ORDER_CAMPAIGNS(workspaceId: number | string = ':workspaceId'): string {
    return `/workspaces/${workspaceId}/campaigns`;
  },
  ORDER_CAMPAIGN_ANALYTICS(workspaceId: number | string = ':workspaceId'): string {
    return `/workspaces/${workspaceId}/campaigns-analytics/:campaignId?`;
  },
  CREATE_NEW_ORDER_CAMPAIGN(workspaceId: number | string = ':workspaceId'): string {
    return `/workspaces/${workspaceId}/new-campaigns/:campaignId?`;
  },
  // Publisher
  WEBSITES(workspaceId: number | string = ':workspaceId'): string {
    return `/workspaces/${workspaceId}/websites`;
  },
  WEBSITE_PAGES(
    workspaceId: number | string = ':workspaceId',
    websiteId: number | string = ':websiteId',
    newWebsiteId: number | string = ':newWebsiteId?'
  ): string {
    return `/workspaces/${workspaceId}/websites/${websiteId}/${newWebsiteId}`;
  },
  WEBSITE_STEP_ONE(
    workspaceId: number | string = ':workspaceId',
    websiteId: number | string = ':newWebsiteId?'
  ): string {
    return `/workspaces/${workspaceId}/websites/new/${websiteId}`;
  },
  WEBSITE_STEP_TWO(
    workspaceId: number | string = ':workspaceId',
    websiteId: number | string = ':websiteId'
  ): string {
    return `/workspaces/${workspaceId}/websites/${websiteId}/price`;
  },
  WEBSITE_STEP_THREE(
    workspaceId: number | string = ':workspaceId',
    websiteId: number | string = ':websiteId'
  ): string {
    return `/workspaces/${workspaceId}/websites/${websiteId}/custom-requirements`;
  },
  WEBSITE_STEP_FOUR(
    workspaceId: number | string = ':workspaceId',
    websiteId: number | string = ':websiteId'
  ): string {
    return `/workspaces/${workspaceId}/websites/${websiteId}/verify-ownership`;
  },
};

export const pagesWithIntercom = [
  urls.LOGIN,
  urls.REGISTER,
  urls.FORGOT_PASSWORD,
  urls.RESTORE_PASSWORD,
  urls.BD_LOGIN,
  urls.TRIAL,
  urls.ONBOARDING_ONBOARDING,
  urls.ONBOARDING_MEMBERS,
  urls.ONBOARDING_TUTORIAL,
  urls.CAMPAIGN_BUILDER(),
  urls.CHANGE_SUBSCRIPTION,
  urls.ORDER(),
  urls.ORDER_INFO(),
  urls.CONCIERGE_FIRST_ORDER,
];

export const intercomLeftPositionPages = [
  urls.LOGIN,
  urls.REGISTER,
  urls.ONBOARDING_CALL,
  urls.FORGOT_PASSWORD,
  urls.RESTORE_PASSWORD,
  urls.CAMPAIGN_BUILDER(),
  urls.ORDER(),
  urls.ORDER_INFO(),
  urls.CONCIERGE_FIRST_ORDER,
];

export const urlPrefixWithoutWorkspace = [
  'dashboard',
  'onboarding',
  'settings',
  'toolbox',
  'maintenance',
  'unsubscribe',
  'unsubscribed',
  'transition-first-order',
  'schedule-call',
  'first-order',
];

export default urls;
